import {Injectable} from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import {SsrCookieService} from "ngx-cookie-service-ssr";

@Injectable()
export class BartenderGuard  {

  constructor(private router: Router,
              private cookieService: SsrCookieService) { }

  canActivate(state: RouterStateSnapshot) {
    if (this.cookieService.get("role") == "BARMAN") {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
}
